var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._g({class:["mpx-root-view","host-_a53ae8d2"]},_vm.$listeners),[_c('theme-container',[_c('div',{class:["base-container"],style:(_vm._f("transRpxStyle")([(_vm.style)]))},[_vm._t("default")],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }